import { Component, OnInit, Input, EventEmitter, Output, ChangeDetectorRef} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { startWith, pairwise } from 'rxjs/operators';
import { CommonBookingService } from '../common-booking.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { BaseFormGroup } from 'src/app/shared/form-input-components/base-form-group';
import { CommonService } from 'src/app/shared/services/common.service';

@Component({
  selector: 'app-send-communication',
  templateUrl: './send-communication.component.html',
  styleUrls: ['./send-communication.component.scss']
})
export class SendCommunicationComponent extends BaseFormGroup implements OnInit {

  @Input() bookings: any[];
  @Output() closeCallback = new EventEmitter();
  @Output() showSuccessToastCallback = new EventEmitter();

  // Actions have 3 different casings for config, templateConfig and send api
  private communicationType = [
    {label: 'Send Email', value: 'Email', templateCasing: 'EMAIL'},
    {label: 'Send SMS', value: 'SMS', templateCasing: 'SMS'},
    {label: 'WhatsApp Communication', value: 'whatsapp', templateCasing: 'whatsapp'},
    // {label: 'App Notification', value: 'App Notification', templateCasing: 'APP NOTIFICATION'}
  ];

  public visibleCommunicationType = [];

  public recipientType = [
    {dropdownLabel: 'Employee', value: 'employee'},
    {dropdownLabel: 'Vendor', value: 'vendor'},
    // {dropdownLabel: 'Transport Manager', value: 'transportManager', label: 'Transport Manager'},
    // {dropdownLabel: 'Approving Manager', value: 'approvingManager'}
  ];

  private employees: any[];
  private vendors: any[];
  public label = "Select Template";
  public formDetails: FormGroup;
  public templates: any = {};
  public selectedMessage: any;
  public config: any;
  public approvingManagers: any[];
  private employeePersonIdMap: any = {};
  public isLoading: boolean;
  updatedRecipientType: string;

  constructor(private commonBookingService: CommonBookingService, private utilService: UtilService,
              private commonService: CommonService, private changeDetectorRef: ChangeDetectorRef,
             ) {
    super();
   }

  ngOnInit() {
    this.commonService.fetchConfig().subscribe((response) => {
      const popupConfig = this.commonService.getConfigForElementKey(response, 'Send Communication Pop-up');
      this.config = {
        action: this.commonService.getConfigForElementKey(popupConfig, 'action'),
        employee: this.commonService.getConfigForElementKey(popupConfig, 'Riders'),
        vendor: this.commonService.getConfigForElementKey(popupConfig, 'Vendor'),
        transportManager: this.commonService.getConfigForElementKey(popupConfig, 'Transport Manager'),
        approvingManager: this.commonService.getConfigForElementKey(popupConfig, 'Approving Manager'),
      };
      this.communicationType.forEach((type) => {
        if (this.config['action'].config.values.indexOf(type.value) >= 0) {
          this.visibleCommunicationType.push(type);
        }
      });
    });
    this.commonBookingService.fetchCommTemplates().subscribe((response) => {
      for (const actionObj of response) {
        const action = this.getActionTemplateCasing(actionObj.action);
        this.templates[action] = {};
        const actionTemplateObj = this.templates[action];
        for (const recipientObj of actionObj.recepientTemps) {
          const templates = this.utilService.deepCopy(recipientObj.templates);
          templates.push({tempName: 'Other'});
          actionTemplateObj[recipientObj.recepientType] = templates;
        }
      }
      this.extractUsersFromBookings();
      this.setupForm();
      this.changeDetectorRef.detectChanges();
    });

  }

  // to handle different casing of actions string in config and template config
  getActionTemplateCasing(action) {
    for (const type of this.communicationType) {
      if (action === type.templateCasing) {
        return type.value;
      }
    }
  }

  setupForm() {
    const employeeEmail = this.employees.map(emp => emp.email);
    this.formDetails =  new FormGroup({
      action: new FormControl('Email', Validators.required),
      recipientType: new FormControl('employee', Validators.required),
      templateName: new FormControl('', Validators.required),
      employee: new FormControl({value: employeeEmail, disabled: true}, this.checkEntries.bind(this, 'employee')),
      vendor: new FormControl({value: [], disabled: true}, this.checkEntries.bind(this, 'vendor')),
      approvingManager: new FormControl({value: [], disabled: true}, this.checkEntries.bind(this, 'approvingManager')),
      tempSub: new FormControl('', this.checkSubject),
      tempBody: new FormControl('', this.checkBody)
    });
    this.formDetails.get('employee').enable();
    this.formDetails.get('action').valueChanges.pipe(startWith('email'), pairwise()).subscribe(this.handleActionChange);
    this.formDetails.get('recipientType').valueChanges.pipe(startWith('employee'), pairwise()).subscribe(this.handleRecipientTypeChange);
    this.formDetails.get('templateName').valueChanges.pipe(startWith(null), pairwise()).subscribe(this.handleTemplateNameChange);
  }

  handleRecipientTypeChange = ([prev, next]) => {
    if (this.formDetails.get('templateName').value !== 'Other') {
      this.formDetails.get('templateName').reset();
    }
    if (prev && this.formDetails.get(prev)) {
      this.formDetails.get(prev).setValue([]);
      this.formDetails.get(prev).markAsPristine();
      this.formDetails.get(prev).disable();

    }

    if (this.formDetails.get(next)) {
      if (next === 'employee') {
        const employeeEmail = this.employees.map(emp => emp.email);
        this.formDetails.get(next).setValue(employeeEmail);
        this.employees.forEach((element) => {
          element.selected = true;
        });
      } else if (next === 'vendor') {
        const vendorIds = this.vendors.map(vendor => vendor.guid);
        this.formDetails.get(next).setValue(vendorIds);
        this.vendors.forEach((element) => {
          element.selected = true;
        });
      }
      this.formDetails.get(next).enable();
    }
  }

  handleActionChange = ([prev, next]) => {
    if (this.formDetails.get('templateName').value !== 'Other') {
      this.formDetails.get('templateName').reset();
    }
  }

  handleTemplateNameChange = ([prev, next]) => {
    const templates = this.getTemplateOptions();
    if (next === 'Other') {
      this.selectedMessage = null;
      return;
    }
    for (const template of templates) {
      if (template.tempName === next) {
        this.selectedMessage = template;
      }
    }
  }

  checkSubject = (control: FormControl) => {
    if (this.formDetails && this.formDetails.get('templateName').value === 'Other' && this.formDetails.get('action').value === 'email') {
      if (!control.value) {
        return {
          required: true
        };
      }
    }
    return null;
  }

  checkBody = (control: FormControl) => {
    if (this.formDetails && this.formDetails.get('templateName').value === 'Other') {
      if (!control.value) {
        return {
          required: true
        };
      }
    }
    return null;
  }

  checkEntries = (type: string, control: FormControl) => {
    if (this.formDetails.get('recipientType').value === type) {
      if (!control.value.length) {
        return {
          required: true
        };
      }
    }
    return null;
  }

  getOptions(type: string) {
    if (type === 'employee') {
      return this.employees;
    } else if (type === 'vendor') {
      return this.vendors;
    } else if (type === 'approvingManager') {
      return this.approvingManagers;
    }
  }

  extractUsersFromBookings() {
    const employeesMap = {};
    const vendorsMap = [];
    const approvingManagersMap = {};
    for (const booking of this.bookings) {
      if (booking.vendor && !vendorsMap[booking.vendor.guid]) {
        vendorsMap[booking.vendor.guid] = booking.vendor;
      }
      if (booking.managerName && booking.managerEmail && !approvingManagersMap[booking.managerEmail]) {
        approvingManagersMap[booking.managerEmail] = {name: booking.managerName,  email: booking.managerEmail};
      }
      for (const stop of booking.stops) {
        for (const rider of stop.riders) {
          if (!employeesMap[rider.email]) {
            employeesMap[rider.email] = rider;
            this.employeePersonIdMap[rider.email] = {[rider.personId]: true};
          }
          if (this.employeePersonIdMap) {
            this.employeePersonIdMap[rider.email][rider.personId] = true;
          }
        }
      }
    }

    this.employees = Object.values(employeesMap);
    this.vendors = Object.values(vendorsMap);
    this.approvingManagers = Object.values(approvingManagersMap);
  }

  onRecipientChange = (value: string) => {
    this.updatedRecipientType = value;
    this.formDetails.get('recipientType').setValue(value);
  }

  getUniqueKeys() {
    const recipientType = this.formDetails.get('recipientType').value;
    if (recipientType === 'employee') {
      const empEmails = this.formDetails.get('employee').value;
      let personIdArr = [];
      empEmails.forEach((email) => {
        personIdArr = personIdArr.concat(Object.keys(this.employeePersonIdMap[email]));
      });
      return personIdArr;
    } else if (recipientType === 'vendor') {
      return this.formDetails.get('vendor').value;
    } else if (recipientType === 'approvingManager') {
      return this.formDetails.get('approvingManager').value;
    }
  }

  private formatBodyForLineBreak(body: string) {
    if (this.formDetails.get('action').value === "Email") {
      return body.replace(/(\n)+/g, '<br>');
    } else if (this.formDetails.get('action').value === "SMS") {
      return body.replace(/(\n)+/g, ' ');
    }
  }
  onSubmitClick = () => {
    if (!this.formDetails.valid) {
      this.markFormGroupDirty(this.formDetails);
    } else {
      this.isLoading = true;
      const request = {
        // Submit api call has yet another casing for action
        action: this.formDetails.get('action').value.toLowerCase().replace(' ', ''),
        bookingIDs: this.bookings.map(booking => booking.bookingId),
        recepientType: this.formDetails.get('recipientType').value,
        tempName: this.formDetails.get('templateName').value,
        tempSubj: this.selectedMessage ? this.selectedMessage.tempSub : this.formDetails.get('tempSub').value,
        tempBody: this.selectedMessage ?
          this.selectedMessage.tempBody :
          this.formatBodyForLineBreak(this.formDetails.get('tempBody').value),
        signature: this.selectedMessage ? this.selectedMessage.signature : null,
        uniqueKeys: this.getUniqueKeys()
      };
      this.commonBookingService.sendCommunication(request).subscribe(() => {
        this.isLoading = false;
        if (this.showSuccessToastCallback) {
          this.showSuccessToastCallback.emit('Communication sent successfully.');
        }
        this.cancelCallback();
      }, () => {
        this.isLoading = false;
      });
    }
  }

  getOptionValue = (option) => {
    return option.guid || option.email;
  }

  getOptionLabel = (option) => {
    return option.name || option.vendorName || option.driverName;
  }

  getTemplateOptions = () => {
    const recipientType = this.formDetails.get('recipientType').value;
    const action = this.formDetails.get('action').value;
    if (recipientType && action) {
      return this.templates[action][recipientType] || [];
    }
    return [];
  }

  getTemplateName = (template: any) => {
    return template.tempName;
  }

  cancelCallback = () => {
    this.closeCallback.emit();
  }

}
